// extracted by mini-css-extract-plugin
export default {"unavailable":"style_unavailable__wZBTa"};